import { Stack } from '@optimus-web/core';
import { CustomerClassificationTag } from './CustomerClassificationTag';
import { UseCustomerClassificationsParams, useCustomerClassificationsSplit } from './useCustomerClassificationsSplit';

type OtherCustomerClassificationsProps = UseCustomerClassificationsParams;

export const OtherCustomerClassifications = ({ classifications }: OtherCustomerClassificationsProps) => {
    const { other } = useCustomerClassificationsSplit({ classifications });

    if (!other || other.length === 0) return null;

    return (
        <Stack spacing="100" itemAlignment="start" vertical>
            {other.map((item) => (
                <CustomerClassificationTag key={item.enumValue} {...item} />
            ))}
        </Stack>
    );
};
